<template>
  <PageTemplate :title="metaTitle" :loading="loading">
    <BannerWidget
      class="mb-4 mb-md-10"
      category="Retângulo"
      type="carousel"
      :items-to-show="{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }"
    />

    <div>
      <div
        v-if="parsedTitle"
        class="text-h6 text-sm-h4 text-lg-h3 font-weight-black text-center mb-2"
      >
        {{ parsedTitle }}
      </div>

      <div class="d-flex justify-space-between align-center mb-4">
        <div class="d-flex flex-column flex-sm-row align-start align-sm-center">
          <v-btn
            v-if="!xsOnly && item.category"
            :to="categoryTo"
            class="mr-4 text-none"
            color="secondary"
            depressed
          >
            {{ item.category.title }}
          </v-btn>
          <div v-if="parsedDate" class="text-body-1">
            <v-icon class="mt-n1" size="14" left>fas fa-calendar-alt</v-icon>
            {{ parsedDate }}
          </div>
        </div>

        <ShareButtonWidget :small="xsOnly" />
      </div>

      <MansoryGallerySection
        v-if="gallerySection.items.length > 1"
        v-bind="gallerySection"
        no-container
        hide-title
      />

      <template v-if="item.authors && item.authors.length">
        <v-divider class="mt-10 mb-6"></v-divider>
        <div>
          <div class="text-body-2 text-center mb-2 mb-sm-1">Foto por:</div>
          <div class="event-view_authors">
            <div
              v-for="(author, keyAuthor) in item.authors"
              :key="keyAuthor"
              class="event-view_author"
            >
              <img
                loading="lazy"
                :src="parseImg(author.img)"
                :alt="author.title"
              />
              <div>
                <div class="text-h5 mt-n1 ml-2 font-weight-medium">
                  {{ author.title }}
                </div>
                <v-btn
                  v-if="author.instagram"
                  :href="author.instagram"
                  target="_blank"
                  class="text-none"
                  small
                  text
                >
                  <v-icon color="#E1306C" left> fab fa-instagram</v-icon>
                  @{{ authorInstagramUser(author.instagram) }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </PageTemplate>
</template>

<script>
import MansoryGallerySection from "../components/sections/MansoryGallerySection.vue";
import BannerWidget from "../components/widgets/BannerWidget.vue";
import PageTemplate from "../components/templates/PageTemplate.vue";
import ShareButtonWidget from "../components/widgets/ShareButtonWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

/**
 * $route.meta = {
 *   mod: string; // Chave do módulo.
 *   ?title: string | (component) => string; // Título da página.
 *   ?params: Record<string, string> | (component) => Record<string, string>; // Parametros da requisição de dados
 * }
 */
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    mod() {
      return this.$route.meta.mod;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },

    item() {
      return this.$rest(this.mod).item;
    },
    parsedTitle() {
      return this.item.title?.replace(/\\"/g, '"');
    },
    parsedDate() {
      return this.item.date
        ? new Date(this.item.date).toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : null;
    },
    gallerySection() {
      const gallerySection = {};

      gallerySection.items = this.item.img?.list || [];
      gallerySection.items = gallerySection.items.map(({ path }) => ({
        src: this.files + path,
        thumbnail: this.files + path + "?resize=1&w=112",
      }));

      gallerySection.cols = {
        xs: 2,
        sm: 3,
        md: 3,
        lg: 4,
        xl: 4,
      };

      return gallerySection;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    categoryTo() {
      const categories = this.$rest("events-categories").list;

      const category = categories.find(
        ({ id }) => id === this.item.category.id
      );

      return category.slug ? `/${category.slug}` : null;
    },
  },
  methods: {
    parseImg(img) {
      if (!img) {
        return DefaultImg;
      }

      return this.files + img;
    },
    authorInstagramUser(instagram) {
      if (!instagram) {
        return null;
      }

      if (instagram.includes("instagram.com/")) {
        const start_index =
          instagram.indexOf("instagram.com/") + "instagram.com/".length;
        const end_index = instagram.indexOf("/", start_index);
        if (end_index === -1) {
          return instagram.substring(start_index);
        } else {
          return instagram.substring(start_index, end_index);
        }
      } else {
        return null;
      }
    },
  },
  watch: {
    itemId() {
      this.$rest(this.mod)
        .get({ id: this.itemId })
        .catch(() => this.$router.replace({ path: "/erro404" }));
    },
  },
  created() {
    this.$rest(this.mod)
      .get({ id: this.itemId })
      .catch(() => this.$router.replace({ path: "/erro404" }))
      .finally(() => (this.loading = false));
  },
  components: {
    BannerWidget,
    MansoryGallerySection,
    PageTemplate,
    ShareButtonWidget,
  },
};
</script>

<style lang="scss">
.event-view_authors {
  align-items: center;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.event-view_author {
  display: grid;
  grid-template-columns: max-content max-content;
  justify-content: center;
  align-items: center;
  gap: 16px;

  img {
    max-width: 120px;
    aspect-ratio: 1;
    width: 100%;
    border-radius: 50% !important;
    object-fit: cover;
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .event-view_author {
    grid-template-columns: auto;
    align-content: center;
    text-align: center;

    img {
      margin: 0 auto;
    }
  }
}
</style>
